import { get, put,Delete,post } from '../axios'

// banner-列表
export const problemList = params => get(`/web/common/problem/list`,params);

// banner-新增
export const problemAdd = params => post(`/web/common/problem/add`,params);

// banner-删除
export const problemDelete = params => Delete('/web/common/problem/delete/' + params.id, '');

// //banner-查看
// export const pcView = params => get('/web/lanxin/url/view/' + params.id, '');

// banner-修改
export const problemUpdate = params => put(`/web/common/problem/update`,params);

